import Vue from 'vue';
import store from './../../store';
import moduleTransformer from './../../transformers/module';

const success = ({ data }, resolve) => {
  const modules = moduleTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllModules', modules);
  resolve(modules);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/module/all')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/modules/items.js